import { useCallback, useMemo, useState } from 'react';
import { createAutocompleteMyType } from '../types';
import useReshape from './use-reshape';
import useGetSources from './use-get-sources';
import useSyncState from './use-sync-state';
function useOnSubmit(onSubmitBase, query) {
  const onSubmit = _ref => {
    let {
      event
    } = _ref;
    if (query) {
      return onSubmitBase(event, query);
    } else {
      return undefined; // no-op
    }
  };

  return useCallback(onSubmit, [onSubmitBase, query]);
}
export default function useAutocomplete(clients, context, onSubmit) {
  const getSources = useGetSources(clients, context);
  const reshape = useReshape(context);
  const {
    autocompleteState,
    onStateChange,
    resetState
  } = useSyncState();
  const {
    0: nonDebouncedQuery,
    1: setNonDebouncedQuery
  } = useState('');
  const safeOnSubmit = useOnSubmit(onSubmit, nonDebouncedQuery);
  const autocomplete = useMemo(() => createAutocompleteMyType({
    getSources,
    reshape,
    onStateChange,
    onSubmit: safeOnSubmit,
    openOnFocus: true
  }), [getSources, reshape, onStateChange, safeOnSubmit]);
  return {
    autocomplete,
    autocompleteState,
    resetState,
    setNonDebouncedQuery
  };
}